export default function imageFormatIsValid(imageUrl?: string) {
  if (!imageUrl) {
    return true;
  }
  return imageUrl.match(/\.(jpeg|jpg|gif|png|webp)/i) != null;
}
